<script lang="ts">
  import {  Col, Container, Row } from 'sveltestrap';
  import LoginForm from './LoginForm.svelte';
</script>
  
<Container fluid class="p-0">
  <Row>
    <Col xs="12">
      <div class="login-card">
        <div class="login-main login-tab">
          <LoginForm />
        </div>
      </div>
    </Col>
  </Row>
</Container>
  